import { render, staticRenderFns } from "./ArticleActions.vue?vue&type=template&id=4f6646d9&"
import script from "./ArticleActions.vue?vue&type=script&lang=ts&"
export * from "./ArticleActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports